// src/constants.ts
var COMPILATION_SORT_OPTIONS = [
  "index",
  "index reverse",
  "date",
  "date reverse",
  "title",
  "title reverse"
];
var DEFAULT_SORT_OPTION = "index";
var CuratedSelectionCompilation = "21cd6705ffba8033bd11d1d5ebd6732a";

// src/schemas.ts
import { z } from "zod";
var UrlSchema = z.string().url();
var NotionIdSchema = z.string().min(1).regex(/^[a-zA-Z0-9]+$/, {
  message: "ID must contain only alphanumeric characters"
});
var ContentIdSchema = NotionIdSchema;
var CompilationIdSchema = NotionIdSchema;
var HighlightIdSchema = NotionIdSchema;
var Iso8601TimestampSchema = z.string().datetime({ message: "Must be a valid ISO 8601 timestamp" });
var PublishDateSchema = z.object({
  year: z.number().int(),
  month: z.number().int().nullable(),
  day: z.number().int().nullable()
});
var MediaSchema = z.object({
  url: UrlSchema
});
var SupplementalMaterialSchema = z.object({
  embed_url: UrlSchema.nullable(),
  content: z.null()
});
var ContentCompilationSchema = z.object({
  compilation_id: CompilationIdSchema,
  title: z.string(),
  index: z.number().int().min(0)
});
var CompilationSortOptionSchema = z.enum(COMPILATION_SORT_OPTIONS);
var CompilationEntrySchema = z.object({
  content_id: ContentIdSchema,
  title: z.string(),
  index: z.number().int().min(0),
  date: PublishDateSchema.nullable()
});
export {
  COMPILATION_SORT_OPTIONS,
  CompilationEntrySchema,
  CompilationIdSchema,
  CompilationSortOptionSchema,
  ContentCompilationSchema,
  ContentIdSchema,
  CuratedSelectionCompilation,
  DEFAULT_SORT_OPTION,
  HighlightIdSchema,
  Iso8601TimestampSchema,
  MediaSchema,
  NotionIdSchema,
  PublishDateSchema,
  SupplementalMaterialSchema,
  UrlSchema
};
//# sourceMappingURL=index.js.map